<ion-card class="card-common-blue ion-no-margin ion-margin-top">

  <!-- Header with back navigation and dynamic vendor/service title -->
  <ion-card-header>
    <ion-card-title (click)="backBtnClicked()" (keydown.enter)="backBtnClicked()" class="cursor-pointer">
      <ion-icon src="assets/imgs/left-chevron.svg" class="iconPadding font24"></ion-icon>

      <ion-text class="ion-margin-start">
        {{ isVendorInfo() && serviceProviderInfo()?.provideR_TITLE ? serviceProviderInfo()?.provideR_TITLE :
        vendoreService()?.sC_SERVICE_TITLE ||
        vendoreService()?.provideR_TITLE}}
      </ion-text>
    </ion-card-title>
  </ion-card-header>

  <ion-card-content class="ion-margin-top">

    <!-- Location search section for vendor lookup -->
    <ion-row>
      <ion-col sizeXs="12" sizeMd="5" class="ion-no-padding">

        <ion-searchbar [(ngModel)]="query" (ionInput)="searchPlace($event)" class="shadow-none searchBar ion-no-padding"
          #serachBox show-clear-button="focus" placeholder="Current Location" (ionBlur)="onBlur()">
        </ion-searchbar>

        <!-- Autocomplete place suggestions list -->
        <ion-list #vendorSearchList id="vendorSearchList" class="p-0">
          @for (place of places(); track $index) {
          <ion-item (click)="selectPlace(place)" (pointerdown)="startSelection()">
            {{ place.description }}
          </ion-item>
          }
        </ion-list>

      </ion-col>
    </ion-row>

    <!-- Validation message displayed when search/location errors occur -->
    @if (validationMsg()) {
    <ion-row class="ion-margin">
      <ion-col class="d-flex justify-content-center ion-padding" size="12">
        {{ validationMsg() }}
      </ion-col>
    </ion-row>
    }

    <!-- Vendor results list rendered when vendors are available -->
    @if (vendorList().length > 0) {

    <ion-card class="card-common ion-no-margin ion-margin-top ion-padding-top ion-padding-bottom">

      <!-- Individual vendor cards -->
      @for (vendor of vendorList(); track $index) {

      <ion-card (click)="goToDirectionPage(vendor)"
        class="card-common vendor-card primary-color ion-padding-top ion-padding-bottom cursor-pointer">
        <ion-grid>
          <ion-row>

            <!-- Vendor icon column -->
            <ion-col class="d-flex justify-content-end" size="1">
              <ion-icon src="assets/imgs/other-defects.svg" class="vendor_icon"></ion-icon>
            </ion-col>

            <!-- Vendor location name -->
            <ion-col size="11" class="font-family-bold">
              {{ vendor.locatioN_NAME }}
            </ion-col>

            <!-- Navigation icon -->
            <ion-col class="d-flex justify-content-end" size="1">
              <ion-icon name="navigate" class="vendor_icon"></ion-icon>
            </ion-col>

            <!-- Distance information -->
            <ion-col size="11">
              {{ vendor.distancE_MILES | number: '1.1-1' : 'en' }} miles
            </ion-col>

            <!-- Address icon -->
            <ion-col class="d-flex justify-content-end" size="1">
              <ion-icon src="assets/InspectionImage/location.svg" class="vendor_icon"></ion-icon>
            </ion-col>

            <!-- Vendor address details -->
            <ion-col size="11">
              {{ vendor.street ? vendor.street + ',' : '' }}
              {{ vendor.city ? ' ' + vendor.city + ',' : '' }} <br>
              {{ vendor.postaL_CODE }}
            </ion-col>

          </ion-row>
        </ion-grid>

      </ion-card>
      }

      <!-- Infinite scroll for lazy loading additional vendors -->
      <ion-infinite-scroll threshold="100px" (ionInfinite)="loadMoreVendor($event)">
        <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Loading more vendors...">
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>

    </ion-card>
    }

  </ion-card-content>
</ion-card>